import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { RowThumb, CategoryPill } from '../ui';
import { formatCurrency } from '../../utils/currencyFormatter';

const buildProductColumns = ({ t, i18n, categoryById, openRowMenu }) => [
  {
    field: 'productName',
    headerName: t('Product Name'),
    flex: 2.6,
    minWidth: 220,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 }}>
        <RowThumb src={params.row.productImage} name={params.row.productName} />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="subtitle1" noWrap>{params.row.productName}</Typography>
          <Typography variant="body2" color="text.secondary" noWrap>{params.row.productDescription}</Typography>
        </Box>
      </Box>
    ),
  },
  {
    field: 'categoryId',
    headerName: t('Category'),
    flex: 1,
    minWidth: 140,
    sortable: false,
    renderCell: (params) => {
      const category = categoryById[params.value];
      if (!category) return null;
      return <CategoryPill color={category.categoryColor} label={category.categoryName} />;
    },
  },
  {
    field: 'unit',
    headerName: t('Unit'),
    flex: 0.7,
    minWidth: 90,
    renderCell: (params) => (
      <Typography variant="body2" color="text.secondary">
        {t('per')} {params.value}
      </Typography>
    ),
  },
  {
    field: 'productPrice',
    headerName: t('Price'),
    flex: 0.7,
    minWidth: 100,
    align: 'right',
    headerAlign: 'right',
    renderCell: (params) => (
      <Typography variant="subtitle1">{formatCurrency(params.value, 'USD', i18n.language)}</Typography>
    ),
  },
  {
    field: 'actions',
    headerName: '',
    width: 72,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <IconButton size="small" onClick={(e) => openRowMenu(e, params.row)} aria-label={t('Actions')}>
        <MoreHorizIcon />
      </IconButton>
    ),
  },
];

export default buildProductColumns;
